import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const accordion = {
    init: function (scope) {
        scope = scope ? scope + ' ' : '';

        $(scope + '.accordion .accordion-header > a').on('click', function () {
            var self = $(this);
            var parent = self.parents('.accordion');

            $('.accordion').not(parent).removeClass('open');
            $('.accordion').not(parent).find('.accordion-content').slideUp();

            parent.toggleClass('open');
            parent.find('.accordion-content').slideToggle(function () {

                if ($(parent).parent().hasClass('lightbox-with-accordion')) {
                    return;
                }

                hash.add({ 'accordion': self.attr('href').replace('#', '') });

                if (isMobileDevice) {
                    $('html, body').animate({ scrollTop: (parent.offset().top - self.outerHeight()) + 'px' }, 500);
                } else {
                    $('html, body').animate({ scrollTop: (parent.offset().top - self.outerHeight()) + 'px' }, 600);
                }
            });

            for (var i = 0; i < window.Highcharts.charts.length; i++) {
                window.Highcharts.charts[i].reflow();
            }

            return false;
        });

        var hashAccordionVal = hash.get('accordion');
        $(scope + '.accordion .accordion-header > a[href="#' + hashAccordionVal + '"]').trigger('click');
    }
};

export default accordion;

App.Util.accordion = accordion;
